
<template>
    <div>
        <div class="top-invite-main-container">
            <color-wallet-icon class="invite-main-icon" />
            <p class="invite-title">{{ $t('invitesPage.invitesKing') }}</p>
            <p class="invite-description">{{ $t('invitesPage.inviteFriendsDescr') }}</p>
            <button class="invite-friends-button" @click="setIsOpenInvitesBlock">{{ $t('invitesPage.inviteFriends')
                }}</button>
            <div class="fin-coin-block">
                <p class="invite-title-fin"><fin-coin-icon class="fin-coin-icon" /> {{ setMainBonus.sum_all || 0 }}
                </p>
            </div>
        </div>
        <div class="inveted-friends-raiting-block">
            <div v-if="friendsArray.length">
                <div v-for="(friend, index) of friendsArray" :key="friend.id" class="invited-friend-item">
                    <award-icon v-if="!index" class="awards-places first" />
                    <award-icon v-else-if="index === 1" class="awards-places second" />
                    <award-icon v-else-if="index === 2" class="awards-places third" />
                    <p v-else class="index-friend">{{ index + 1 }}</p>
                    <template v-if="friend.referent">
                    <img v-if="friend.referent.img" :src="friend.referent.img" alt=""
                        class="page-header-customer-notification-image">
                    <div v-else class="friend-image-icon-container">
                        <question-mark-icon class="friend-image-icon" />
                    </div>
                    <div class="friend-info-container">
                        <p class="friend-name">{{ friend.referent.name }}</p>
                        <p class="friend-fin-price">{{ friend.sum }} fin <span class="friend-last-income">+200</span>
                            <fin-coin-icon class="last-income-coins-icon" />
                        </p>
                    </div>
                    </template>
                    <template v-else>
                    <div class="friend-image-icon-container">
                        <question-mark-icon class="friend-image-icon" />
                    </div>
                    <div class="friend-info-container">
                        <p class="friend-name">Бонус за переливання трафіку</p>
                        <p class="friend-fin-price">{{ friend.sum }} fin <span class="friend-last-income">+200</span>
                            <fin-coin-icon class="last-income-coins-icon" />
                        </p>
                    </div>
                    </template>

                </div>
            </div>

            <div v-if="!friendsArray.length" class="null-operations-block">
                <p class="null-operations-text">{{ $t('invitesPage.invitedFriendsNull') }}</p>
            </div>
        </div>
    </div>
</template>

<script>


import { AwardIcon } from 'vue-feather-icons';
// import QuestionMarkIcon from '../icons/QuestionMarkIcon.vue';
// import CoinIcon from '../icons/CoinIcon.vue';
import { mapMutations } from "vuex"
import ColorWalletIcon from '../icons/ColorWalletIcon.vue';
import { onVibrate } from '../../../helpers/utils.js';
import { setMakeDate } from '../../../helpers/utils.js';
import FinCoinIcon from '../icons/FinCoinIcon.vue';

export default {
    name: "Buttons-top-container",
    components: {
        ColorWalletIcon,
        // QuestionMarkIcon,
       // CoinIcon,
        AwardIcon,
        FinCoinIcon,
        // PlusIcon,
        // ActivityIcon,
        // AwardIcon,
        // BellIcon,
        // BoxIcon,
        // CalendarIcon,
    },
    props: {
        activeType: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            friendsArray: []
        }
    },
    async mounted() {
        let customer_id = this.currentCustomer.customer_id
       let data = {
           customer_id: customer_id,
           from: '',
           to: setMakeDate({id: 0}).to
       }
        this.$store.dispatch('getInvitesLink', customer_id)
       this.$store.dispatch('getInvitedFriends', data).then(val => {
        console.log({val})
           this.friendsArray = val
       })

    },

    methods: {
        ...mapMutations([]),
       setIsOpenInvitesBlock() {
           onVibrate('click')
           this.$emit('is-open-invites-block')
       }
    },
    computed: {
        getCustomers() {
            return this.$store.getters.getCustomers;
        },
        getInvitedFriends() {
            return this.$store.getters.getInvitedFriends;
        },
        currentCustomer() {
            return this.$store.getters.currentCustomer;
        },
        setMainBonus() {
            return this.$store.getters.setMainBonus
        },
    },
    watch: {

    }
}
</script>

<style scoped>
    .last-income-coins-icon {
        width: 15px;
        height: 15px;
    }
    .top-invite-main-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
    }
    .invite-main-icon {
        margin: 20px auto;
        transform: rotate(-10deg);
    }
    .invite-title {
        font-family: "Source Sans 3", sans-serif;
        font-size: 28px;
        line-height: 30px;
        color: #1b1b1b;
        letter-spacing: -0.6px;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .invite-description {
        color: #747474;
        font-family: "Source Sans 3", sans-serif;
        margin-bottom: 30px;
        letter-spacing: -0.2px;
        font-size: 15px;
        opacity: 0.7;
        margin-bottom: 20px;
        line-height: 12px;
    }

    .invite-friends-button {
        display: block;
        font-family: "Source Sans 3", sans-serif;
        text-transform: uppercase;
        font-weight: 700;
        border-radius: 12px;
        font-size: 13px;
        padding: 10px 20px;
        box-shadow: 0 5px 14px 0 rgba(0, 0, 0, 0.1);
        transition: all 120ms ease;
        background-size: cover;
        position: relative;
        z-index: 10;
        background-image: var(--main-bg-color);;
        color: #FFF;
        width: 50%;
        border: none;
        margin: 0 auto;
        cursor: pointer;
    }

    .invite-friends-button::after {
        content: "";
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background: inherit;
        z-index: -1;
        transform: scale(0.8) translateY(5px) translateZ(0px);
        filter: blur(12px);
    }
    .inveted-friends-raiting-block {
        border-radius: 22px;
        width: 95%;
        margin: 0 auto;
        background: #FFF;
        overflow: hidden;
        padding: 15px;
        margin-top: 15px;
        margin-bottom: 50px;
        box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
    }
    .invited-friend-item {
        display: flex;
        gap: 10px;
        padding: 5px 0px;
    }
    .index-friend {
        width: 24px;
        line-height: 45px;
        text-align: center;
        color: #747474;
        margin-bottom: 30px;
        letter-spacing: -0.2px;
        font-size: 13px;
        opacity: 0.7;
        margin-bottom: 0px;
    }
    .friend-image-icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 45px;
        height: 45px;
        transition: all 120ms ease;
        border-radius: 15px;
        border: none;
        background-image: var(--main-bg-color);
        position: relative;
        z-index: 10;
        overflow: visible !important;
    }
    .friend-image-icon {
        fill: #fff;
    }

    .fin-coin-block {
        width: 200px;
        margin: 0 auto;
        background: #ffffff;
        border-radius: 15px;
        margin-top: 15px;
        padding: 7px;
        box-shadow: 10px 10px 10px #d1d9e6, -10px -10px 10px #f9f9f9;
    }

    .fin-coin-icon {
        width: 25px;
        height: 25px;
        vertical-align: -3px;
    }

    .invite-title-fin {
        font-family: "Source Sans 3", sans-serif;
        font-size: 28px;
        line-height: 30px;
        color: #1b1b1b;
        letter-spacing: -0.6px;
        font-weight: 600;
    }

    .page-header-customer-notification-image {
            position: relative;
            width: 45px;
            height: 45px;
            border-radius: 20px;
        }
    .friend-name {
        font-family: "Source Sans 3", sans-serif;
        color: #1b1b1b;
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        margin-bottom: 0px;
    }
    .friend-fin-price {
        color: #747474;
        margin-bottom: 30px;
        letter-spacing: -0.2px;
        font-size: 11px;
        opacity: 0.7;
        margin-bottom: 0px;
        line-height: 12px;
    }
    .null-operations-block {
        display: flex;
        justify-content: center;
    }
    .null-operations-text {
        font-size: 15px;
        line-height: 23px;
        font-weight: 500;
        color: #747474;
        font-family: "Source Sans 3", sans-serif;
        letter-spacing: -0.6px;
    }
    .friend-last-income {
        color: #e79500;
    }
    .last-income-coins-icon {
        vertical-align: -3px;
        margin-left: 5px;
    }
    .awards-places {
        margin: auto 0;
    }
    .awards-places.first {
        color: #ffd700;
    }
    .awards-places.second {
        color: #c0c0c0;
    }
    .awards-places.third {
        color: #bb7a03;
    }

</style>